var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('statistical-header',{attrs:{"title":"Parliamentary Office Holders timeline"}}),_c('statutory-office-holder-timeline'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }